"use client";

import { IconConfetti } from "@decibeltrade/react-icons";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { css } from "styled-system/css";

import { Banner } from "@/components/banner";
import { Collapsible } from "@/components/collapsible";
import { useDecibelWallet } from "@/hooks/use-decibel-wallet";

const FLAGGED_ADDRESSES: Record<string, string> = {
  "0x3b8e663408a31c63c1d7f9f393f04c20d4e0b8e1a980f2d8fceb89228e3b6945": "$32,276.72",
  "0x39a237f71f16998a3b4087879c398ea83d89f33bc4a23a01643e05dc4bb3f31d": "$1,676,659.22",
  "0xcf0c101739ca276523bce39aa1665ac1cf9ac458e91b0d508f168ce5d46230c": "$32,253.36",
  "0xe9cedfe6837be0fa8838c44089ed1e24b8911a7b3d7ad84b31f69032b6452510": "$46,645.82",
};

const DISMISSED_KEY = "contact-banner-dismissed";

const TELEGRAM_URL = "https://t.me/avgnomad";

const linkStyles = css({ textDecoration: "underline", _hover: { opacity: 0.8 } });

export function ContactBanner() {
  const { accountAddress } = useDecibelWallet();
  const t = useTranslations("contactBanner");
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.sessionStorage.getItem(DISMISSED_KEY) === "true";
  });

  const volume = accountAddress ? FLAGGED_ADDRESSES[accountAddress.toLowerCase()] : undefined;
  const show = !dismissed && !!volume;

  return (
    <Collapsible open={show}>
      <Collapsible.Content>
        <Banner
          variant="positive"
          className={css({ width: "full", justifyContent: "center" })}
          onDismiss={() => {
            setDismissed(true);
            window.sessionStorage.setItem(DISMISSED_KEY, "true");
          }}
        >
          <IconConfetti className={css({ h: "16", w: "16", flexShrink: 0 })} />
          <span>
            {t.rich("message", {
              volume: volume ?? "",
              telegramLink: (chunks) => (
                <a
                  href={TELEGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkStyles}
                >
                  {chunks}
                </a>
              ),
            })}
          </span>
        </Banner>
      </Collapsible.Content>
    </Collapsible>
  );
}
